import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
// import { Input } from '@/common/components/Input.tsx'
// import FormErrorMessage from '@/common/components/FormErrorMessage.tsx'
// import { Button } from '@/common/components/Button.tsx'
// import { EditIcon } from '@/common/icons/general.tsx'
// import { MyAccountFormFields } from '../models.tsx'
// import { ChangeHandler } from 'react-hook-form'
// import { forwardRef } from 'react'

export const FormRowLayout = ({
  children,
  className,
}: ChildrenProp & { className?: string }) => {
  return (
    <div
      className={cn(
        'text-sm font-semibold rounded-md  py-4 px-2 sm:py-2 flex  justify-between items-center ',
        className
      )}
    >
      {children}
    </div>
  )
}

export const FormLoadingOverlay = () => {
  return (
    <>
      <div className="absolute top-0 right-0 left-0 h-[3px] z-20 bg-primary animate-pulse"></div>
      <div className="absolute top-0 right-0 bottom-0 left-0 z-10 bg-neutral-50/50"></div>
    </>
  )
}

// type FormRowProps = {
//   title: string
//   name: MyAccountFormFields
//   errorMessage?: string
//   editModeEnabled: (field: MyAccountFormFields) => boolean
//   toggleEditMode: (field: MyAccountFormFields) => void
//   placeholder?: string
//   fieldIsEditable: boolean
//   onChange: ChangeHandler
//   onBlur: ChangeHandler
// }
//
//
// export const FormRow = forwardRef<HTMLInputElement, FormRowProps>(
//   (
//     {
//       title,
//       // register,
//       name,
//       editModeEnabled,
//       errorMessage,
//       toggleEditMode,
//       placeholder,
//       fieldIsEditable,
//       onBlur,
//       onChange,
//     },
//     ref
//   ) => {
//     return (
//       <>
//         <div className="space-y-1">
//           <span>{title}</span>
//           <div className={cn('block sm:hidden')}>
//             <Input
//               name={name}
//               onChange={onChange}
//               onBlur={onBlur}
//               ref={ref}
//               className={cn(
//                 'text-sm max-w-56',
//                 !editModeEnabled(name) &&
//                   'shadow-none ring-0 pl-0 text-gray-600 font-medium focus:ring-0 caret-transparent'
//               )}
//               placeholder={placeholder}
//               readOnly={!editModeEnabled(name)}
//             />
//             <FormErrorMessage message={errorMessage ?? ''} />
//           </div>
//         </div>
//         <div className={cn('hidden sm:block')}>
//           <Input
//             name={name}
//             onChange={onChange}
//             onBlur={onBlur}
//             ref={ref}
//             className={cn(
//               'max-w-56',
//               !editModeEnabled(name) &&
//                 'shadow-none ring-0 pl-0 text-sm text-gray-600 font-medium focus:ring-0 caret-transparent w-auto'
//             )}
//             readOnly={!editModeEnabled(name)}
//             placeholder={placeholder}
//           />
//           <FormErrorMessage message={errorMessage ?? ''} />
//         </div>
//         <div className="justify-self-end">
//           {fieldIsEditable ? (
//             <Button
//               onClick={() => toggleEditMode(name)}
//               className="shadow-none hover:bg-primary-50 hover:shadow-sm"
//               variant="ghost"
//               size="sm"
//             >
//               <EditIcon className="text-lg text-primary" />
//             </Button>
//           ) : null}
//         </div>
//       </>
//     )
//   }
// )
